/** @jsxImportSource @emotion/react */

import { ReactNode, useState } from "react";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import * as styles from "./bottomBar.styles";
import { Button } from "../Button";

export const BottomBar = ({ children }: {children: ReactNode}) => {
    const [isLauncherOpen, setIsLauncherOpen] = useState(false);

    return (
        <div css={styles.bottomBarStyles}>
            <div>
                <div className="d-none d-md-flex py-md-4 w-100">
                    <div className="rounded shadow-lg p-3 bg-white w-100 d-flex align-items-center justify-content-md-between gap-2 flex-wrap">
                        {children}
                    </div>
                </div>

                <Button color="primary" rounded icon={faPlus} onClick={() => setIsLauncherOpen(true)} className="d-flex d-md-none" />
            </div>

            <Modal isOpen={isLauncherOpen} toggle={() => setIsLauncherOpen(false)} className="launcher" modalClassName="slide-up" backdropClassName="slide-up">
                <ModalHeader toggle={() => setIsLauncherOpen(false)} />

                <ModalBody css={styles.launcherStyles}>
                    {children}
                </ModalBody>
            </Modal>
        </div>
    );
};
